import { render, staticRenderFns } from "./toSelf.vue?vue&type=template&id=b77fd162&scoped=true"
import script from "./toSelf.vue?vue&type=script&lang=js"
export * from "./toSelf.vue?vue&type=script&lang=js"
import style0 from "./toSelf.vue?vue&type=style&index=0&id=b77fd162&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b77fd162",
  null
  
)

export default component.exports